"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createValidators = exports.DEFAULT_FORM = void 0;
const validators_1 = require("@hooks/forms/validators");
const bignumber_js_1 = __importDefault(require("bignumber.js"));
exports.DEFAULT_FORM = { tickets: "0" };
const createValidators = (balance, ticketPrice, translator) => {
    return {
        tickets: [
            (0, validators_1.createRequiredValidator)(translator("validation.required")),
            (0, validators_1.createLessOrEqualThanValidator)(new bignumber_js_1.default(balance).div(ticketPrice).toNumber(), translator("validation.balanceNotEnough")),
        ],
    };
};
exports.createValidators = createValidators;
